import { render } from "./TextbookSeriesModal.vue?vue&type=template&id=3d39759e&scoped=true"
import script from "./TextbookSeriesModal.vue?vue&type=script&lang=js"
export * from "./TextbookSeriesModal.vue?vue&type=script&lang=js"

import "./TextbookSeriesModal.vue?vue&type=style&index=0&id=3d39759e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d39759e"]])

export default __exports__